import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { ProductBuilderProps } from "./productBuilder/components/ProductBuilder";
import loadable from "@loadable/component";
import { productOptions } from "../pluginOwners";

export const ProductBuilderComponent: ComponentToBeRegistered<ProductBuilderProps> = {
  placeholder: Placeholder.ProductBuilder,
  Component: loadable<ProductBuilderProps>(() =>
    import("./productBuilder/components/ProductBuilder")
  ),
  name: "ProductBuilderComponent",
  dataNeeds: {
    contentful: {
      outOfStock: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "availability.OutOfStock",
      },
      shippingInformation: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntryMarkdown,
        contentfulName: "Shipping Information",
      },
      shippingExclusion: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Shipping exclusion",
      },
      dismissAlert: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Dismiss Alert",
      },
      bulkOrderQuantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Bulk Order > Quantity",
      },
      quantity: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Quantity",
      },
      recommended: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.Recommended",
      },
      outOfStockButtonAttribute: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page v2 > Out Of Stock",
      },
      newCalloutText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "callout.New",
      },
      dropdownIncompatibleMessage: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Dropdown Incompatible Option Message",
      },
      satisfactionGuaranteed: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Guarantee",
      },
      requiredInformationErrorToast: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Required Information Toast",
      },
      satisfactionGuaranteedImageOnPageBuilder: {
        contentType: SupportedPluginContentfulDataType.CloudinaryImageComponent,
        contentfulName: "Product Page > Satisfaction Guaranteed Icon Black",
        transformations: {
          transformedCloudinaryUrl:
            'transformedCloudinaryUrl(color: "rgb:666666", effect: "colorize:100")',
        },
        transformationsMcs: {
          transformedCloudinaryUrl: "color=rgb:666666,effect=colorize:100",
        },
      },
      selectorIncompatibleText: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Selector Incompatible Text",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    return true;
  },
};

export const productBuilder: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, ProductBuilderComponent);
  },
  pluginOwner: productOptions,
};
